import { render, staticRenderFns } from "./NFTVideoTestFullScreen.vue?vue&type=template&id=6502bfdd"
import script from "./NFTVideoTestFullScreen.vue?vue&type=script&lang=js"
export * from "./NFTVideoTestFullScreen.vue?vue&type=script&lang=js"
import style0 from "./NFTVideoTestFullScreen.vue?vue&type=style&index=0&id=6502bfdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports